import { c as _c } from "react/compiler-runtime";
import { AspectRatio, Box, Button, Heading, Link, SimpleGrid, Stack, Text, VStack, Dialog } from '@chakra-ui/react';
import { ButtonStack } from '@src/components/sco/ButtonStack';
import { CardCarousel } from '@src/components/sco/CardCarousel';
import { MobileBottomControl } from '@src/components/sco/CardCarousel/Controls/MobileBottomControl';
import { InvestorSearchesList } from '@src/components/sco/InvestorMatching/InvestorSearchesList';
import { GenericBlock } from '@src/components/sco/LayoutBlocks/GenericBlock';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { ChakraNextImage } from '@src/components/sco/utilities/ChakraNextImage';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import NextLink from 'next/link';
import React, { useState } from 'react';
import { LuChevronRight } from 'react-icons/lu';
import ReactPlayer from 'react-player';
export const HeroBlock = () => {
  const $ = _c(71);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const [showVideo, setShowVideo] = useState(false);
  const {
    currentUser
  } = useCurrentUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      title: "Match",
      description: "Find & rank the ideal investors.",
      image: require("@public/assets/illustration/investor-outreach/match-score_sep.png")
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      title: "Prepare",
      description: "Generate the perfect email pitches.",
      image: require("@public/assets/illustration/investor-outreach/pitch-deck_sep.png")
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [t0, t1, {
      title: "Pitch",
      description: "Automate investor email outreach.",
      image: require("@public/assets/illustration/investor-outreach/automate-outreach-sep.png")
    }];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const cards = t2;
  let t3;
  if ($[3] !== getBreakpointValue) {
    t3 = getBreakpointValue([0, 0, 0, 2, 4, 20]);
    $[3] = getBreakpointValue;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = {
      paddingTop: t3
    };
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== getBreakpointValue) {
    t5 = getBreakpointValue([6, 6, 10, 10, 12]);
    $[7] = getBreakpointValue;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== getBreakpointValue) {
    t6 = getBreakpointValue(["3xl", "4xl", "4xl", "4xl", "5xl", "6xl"]);
    $[9] = getBreakpointValue;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <Heading as="h1" backgroundClip="text" backgroundImage="linear-gradient(90deg, #d97258 0%, #9858a3 100%)" color="transparent" size={t6}>Raise Capital 10x Faster</Heading>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== getBreakpointValue) {
    t8 = getBreakpointValue(["xl", "xl", "xl", "2xl", "3xl"]);
    $[13] = getBreakpointValue;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = <Heading as="h2" color="mocha" fontSize={t8} fontWeight="600">Automate your fundraise with investor matching and outreach.</Heading>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t7 || $[18] !== t9) {
    t10 = <VStack align="center" gap={2} textAlign="center">{t7}{t9}</VStack>;
    $[17] = t7;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== currentUser?.investorSearches?.pagination?.itemCount || $[21] !== getBreakpointValue) {
    t11 = currentUser?.investorSearches?.pagination?.itemCount > 0 && <InvestorSearchesList excludeEmptyResults={true} hideIfEmpty={true} resultsSimpleGridProps={{
      columns: getBreakpointValue([1, 2, 3, 3]),
      gap: 2
    }} investorSearchCardProps={{
      ctaType: "open"
    }} wrapperProps={{
      bgColor: "colorPalette.container",
      borderRadius: "lg",
      boxShadow: "sm",
      padding: getBreakpointValue(["4", "4", "6", "6"]),
      width: "full",
      marginX: "auto"
    }} />;
    $[20] = currentUser?.investorSearches?.pagination?.itemCount;
    $[21] = getBreakpointValue;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== getBreakpointValue) {
    t12 = getBreakpointValue({
      base: false,
      md: true
    }) ? <SimpleGrid columns={3} gap={0}>{cards.map(_temp)}</SimpleGrid> : <CardCarousel fade={false} spacing="0" visibleCards={[1]} controls={{
      top: false,
      bottom: MobileBottomControl
    }}>{cards.map(_temp2)}</CardCarousel>;
    $[23] = getBreakpointValue;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== getBreakpointValue) {
    t13 = getBreakpointValue(["lg", "lg", "lg", "xl"]);
    $[25] = getBreakpointValue;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <NextLink href="/investors/matching/start">Start Pitching Investors<LuChevronRight /></NextLink>;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t13) {
    t15 = <ButtonStack><Button asChild={true} size={t13} variant="cta">{t14}</Button></ButtonStack>;
    $[28] = t13;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Text color="textPrimary" marginTop={4} textAlign="center" textStyle="labelMd">{"Our team is happy to answer any questions. Give us a call at"}{" "}<Link color="yellow.600" href="tel:+18446380008" variant="underline">+1 844-638-0008</Link></Text>;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t15) {
    t17 = <Box marginX="auto" maxWidth="container.sm">{t15}{t16}</Box>;
    $[31] = t15;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t10 || $[34] !== t11 || $[35] !== t12 || $[36] !== t17 || $[37] !== t5) {
    t18 = <VStack align="stretch" gap={t5}>{t10}{t11}{t12}{t17}</VStack>;
    $[33] = t10;
    $[34] = t11;
    $[35] = t12;
    $[36] = t17;
    $[37] = t5;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  let t20;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = t21 => {
      const {
        open
      } = t21;
      if (!open) {
        setShowVideo(false);
      }
    };
    t20 = <Dialog.Backdrop />;
    $[39] = t19;
    $[40] = t20;
  } else {
    t19 = $[39];
    t20 = $[40];
  }
  let t21;
  if ($[41] !== getBreakpointValue) {
    t21 = getBreakpointValue([4, 4, 8]);
    $[41] = getBreakpointValue;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <Dialog.CloseTrigger />;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Box><AspectRatio ratio={1.7777777777777777}><ReactPlayer controls={true} height="100%" playing={true} style={{
          borderRadius: "1em",
          border: "1em solid blackAlpha.500"
        }} url="https://youtu.be/dQw4w9WgXcQ" width="100%" /></AspectRatio></Box>;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== getBreakpointValue) {
    t24 = getBreakpointValue(["stretch", "stretch", "center"]);
    $[45] = getBreakpointValue;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] !== getBreakpointValue) {
    t25 = getBreakpointValue(["column", "column", "row"]);
    $[47] = getBreakpointValue;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] !== getBreakpointValue) {
    t26 = getBreakpointValue(["stretch", "stretch", "space-between"]);
    $[49] = getBreakpointValue;
    $[50] = t26;
  } else {
    t26 = $[50];
  }
  let t27;
  if ($[51] !== getBreakpointValue) {
    t27 = getBreakpointValue(["lg", "lg", "2xl"]);
    $[51] = getBreakpointValue;
    $[52] = t27;
  } else {
    t27 = $[52];
  }
  let t28;
  if ($[53] !== t27) {
    t28 = <Heading fontSize={t27} textAlign="center">Ready to give it a try?</Heading>;
    $[53] = t27;
    $[54] = t28;
  } else {
    t28 = $[54];
  }
  let t29;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <Button asChild={true} size="xl" variant="cta"><NextLink href="/investors/matching/start">See My Investor Matches<LuChevronRight /></NextLink></Button>;
    $[55] = t29;
  } else {
    t29 = $[55];
  }
  let t30;
  if ($[56] !== t24 || $[57] !== t25 || $[58] !== t26 || $[59] !== t28) {
    t30 = <VStack align="stretch" gap={8}>{t23}<Stack align={t24} direction={t25} gap={4} justify={t26}>{t28}{t29}</Stack></VStack>;
    $[56] = t24;
    $[57] = t25;
    $[58] = t26;
    $[59] = t28;
    $[60] = t30;
  } else {
    t30 = $[60];
  }
  let t31;
  if ($[61] !== t21 || $[62] !== t30) {
    t31 = <Dialog.Positioner><Dialog.Content maxWidth="container.lg"><Dialog.Body bgColor="colorPalette.bg" borderRadius="lg" paddingX={t21} paddingY={10}>{t22}{t30}</Dialog.Body></Dialog.Content></Dialog.Positioner>;
    $[61] = t21;
    $[62] = t30;
    $[63] = t31;
  } else {
    t31 = $[63];
  }
  let t32;
  if ($[64] !== showVideo || $[65] !== t31) {
    t32 = <Dialog.Root open={showVideo} onOpenChange={t19}>{t20}{t31}</Dialog.Root>;
    $[64] = showVideo;
    $[65] = t31;
    $[66] = t32;
  } else {
    t32 = $[66];
  }
  let t33;
  if ($[67] !== t18 || $[68] !== t32 || $[69] !== t4) {
    t33 = <GenericBlock boxProps={t4}>{t18}{t32}</GenericBlock>;
    $[67] = t18;
    $[68] = t32;
    $[69] = t4;
    $[70] = t33;
  } else {
    t33 = $[70];
  }
  return t33;
};
function _temp(card, idx) {
  return <VStack key={idx} align="center" gap={1} textAlign="center"><Heading as="h3" color="primaryActive">{card.title}</Heading><Text as="p" color="colorPalette.fg/70" fontSize="lg">{card.description}</Text><ChakraNextImage alt={card.title} maxWidth="380px" src={card.image} width="100%" /></VStack>;
}
function _temp2(card_0, idx_0) {
  return <VStack key={idx_0} align="center" gap={1} textAlign="center"><Heading as="h3" color="primaryActive">{card_0.title}</Heading><Text as="p" color="colorPalette.fg/70" fontSize="lg">{card_0.description}</Text><ChakraNextImage alt={card_0.title} maxWidth="420px" src={card_0.image} width="100%" /></VStack>;
}